
import {Vue} from "vue-class-component";

export default class RegisterPrivacyPolicy extends Vue {
}
